import { render, staticRenderFns } from "./OverlayClose.vue?vue&type=template&id=0c49700c&"
import script from "./OverlayClose.vue?vue&type=script&lang=js&"
export * from "./OverlayClose.vue?vue&type=script&lang=js&"
import style0 from "./OverlayClose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports